<template>
  <!-- Two stacked strips: the personal calendar on top with two busy blocks,
       GrowthMentor availability below with the matching slots greyed out
       and an arrow between them. Sync reads busy time; that is the pitch. -->
  <svg
    width="220"
    height="96"
    viewBox="0 0 220 96"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <rect
      x="10"
      y="8"
      width="200"
      height="30"
      rx="6"
      fill="#fff"
      stroke="#e4e4e7"
    />
    <rect x="16" y="14" width="34" height="5" rx="2.5" fill="#d4d4d8" />
    <g stroke="#f4f4f5">
      <path d="M60 8v30M85 8v30M110 8v30M135 8v30M160 8v30M185 8v30" />
    </g>
    <rect
      x="63"
      y="22"
      width="44"
      height="12"
      rx="3"
      fill="#fecaca"
      stroke="#f87171"
    />
    <rect x="68" y="27" width="24" height="2" rx="1" fill="#b91c1c" />
    <rect
      x="138"
      y="22"
      width="19"
      height="12"
      rx="3"
      fill="#fecaca"
      stroke="#f87171"
    />
    <rect x="143" y="27" width="9" height="2" rx="1" fill="#b91c1c" />

    <path
      d="M110 40v10"
      stroke="#a1a1aa"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M106 47l4 4 4-4"
      stroke="#a1a1aa"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />

    <rect
      x="10"
      y="56"
      width="200"
      height="30"
      rx="6"
      fill="#fff"
      stroke="#e4e4e7"
    />
    <rect x="16" y="62" width="40" height="5" rx="2.5" fill="#c4b5fd" />
    <g stroke="#f4f4f5">
      <path d="M60 56v30M85 56v30M110 56v30M135 56v30M160 56v30M185 56v30" />
    </g>
    <g fill="#ede9fe" stroke="#c4b5fd">
      <rect x="37" y="70" width="20" height="12" rx="3" />
      <rect x="113" y="70" width="20" height="12" rx="3" />
      <rect x="163" y="70" width="20" height="12" rx="3" />
      <rect x="188" y="70" width="18" height="12" rx="3" />
    </g>
    <g fill="#f4f4f5" stroke="#d4d4d8" stroke-dasharray="2 2">
      <rect x="63" y="70" width="44" height="12" rx="3" />
      <rect x="138" y="70" width="19" height="12" rx="3" />
    </g>
  </svg>
</template>
